<template>
  <div class="row-data">
    <div class="tdi-toolbar-card">
      <div class="tdi-card-head">
        <div>
          <p class="tdi-card-title">Biểu đồ thống kê học phí</p>
          <p class="tdi-card-subtitle">Thống kê dữ liệu Phiếu thu, thu/chi theo các tháng trong năm</p>
        </div>
      </div>
    </div>

    <!-- Phiếu thu -->
    <div class="sk-panel sk-panel--flat sk-u-mt-12" style="box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); border: 1px solid #e2e8f0; padding: 20px; border-radius: 8px;">
      <!-- Vùng filter Phiếu thu -->
      <el-form
          ref="searchFormOrderRef"
          :model="dataSearchOrder"
          label-position="top"
          class="tdi-form-grid"
      >
        <el-form-item label="Năm" class="tdi-form-item">
          <el-date-picker
              v-model="dataSearchOrder.year"
              type="year"
              placeholder="Chọn năm"
              style="width: 120px"
              format="yyyy"
              value-format="yyyy"
              :clearable="false"
              @change="loadDataOrder"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="Trạng thái học" class="tdi-form-item">
          <el-select
              v-model="dataSearchOrder.kidStatus"
              placeholder="Trạng thái học"
              clearable
              style="width: 160px"
              @change="loadDataOrder"
          >
            <el-option
                v-for="item in kidStatusListExcel"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>

          <el-form-item label="Trạng thái" class="tdi-form-item">
          <el-select
              v-model="dataSearchOrder.category"
              placeholder="Trạng thái"
              clearable
              style="width: 140px"
              @change="loadDataOrder"
          >
            <el-option label="Tất cả lớp" value="CLASS"></el-option>
            <el-option label="Tất cả nhóm" value="GROUP"></el-option>
            <el-option label="Tất cả gói" value="PACKAGE"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- Bảng tóm tắt hóa đơn -->
      <el-row :gutter="20" style="margin: 20px 0;">
        <el-col :offset="4" :span="8">
          <div class="stat-card stat-card--blue">
            <div class="stat-icon"><i class="el-icon-document-checked"></i></div>
            <div class="stat-content">
              <div class="stat-title">Đã hoàn thành</div>
              <div class="stat-value">{{ totalCompletedOrders }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stat-card stat-card--red">
            <div class="stat-icon"><i class="el-icon-document-delete"></i></div>
            <div class="stat-content">
              <div class="stat-title">Chưa hoàn thành</div>
              <div class="stat-value">{{ totalPendingOrders }}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div style="height: 400px; width: 100%; position: relative;" v-loading="loadingOrder">
        <ChartLine
            v-if="!loadingOrder && orderChartData.datasets.length"
            :checkLable="true"
            :chartData="orderChartData"
            :options="orderChartOptions"
            style="height: 100%; width: 100%;"
        ></ChartLine>
      </div>
    </div>

    <!-- Doanh thu -->
    <div class="sk-panel sk-panel--flat sk-u-mt-12" style="box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); border: 1px solid #e2e8f0; padding: 20px; border-radius: 8px; margin-top: 30px;">
      <!-- Vùng filter Doanh thu -->
      <el-form
          ref="searchFormRevenueRef"
          :model="dataSearchRevenue"
          label-position="top"
          class="tdi-form-grid"
      >
        <el-form-item label="Năm" class="tdi-form-item">
          <el-date-picker
              v-model="dataSearchRevenue.year"
              type="year"
              placeholder="Chọn năm"
              style="width: 120px"
              format="yyyy"
              value-format="yyyy"
              :clearable="false"
              @change="loadDataRevenue"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="Trạng thái học" class="tdi-form-item">
          <el-select
              v-model="dataSearchRevenue.kidStatus"
              placeholder="Trạng thái học"
              clearable
              style="width: 160px"
              @change="loadDataRevenue"
          >
            <el-option
                v-for="item in kidStatusListExcel"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>

          <el-form-item label="Trạng thái" class="tdi-form-item">
          <el-select
              v-model="dataSearchRevenue.category"
              placeholder="Trạng thái"
              clearable
              style="width: 140px"
              @change="loadDataRevenue"
          >
            <el-option label="Tất cả lớp" value="CLASS"></el-option>
            <el-option label="Tất cả nhóm" value="GROUP"></el-option>
            <el-option label="Tất cả gói" value="PACKAGE"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái kết chuyển" class="tdi-form-item">
          <el-select
              v-model="dataSearchRevenue.status"
              placeholder="Trạng thái kết chuyển"
              clearable
              style="width: 180px"
              @change="loadDataRevenue"
          >
            <el-option label="Sang tháng sau" value="MONEY_MONTH"></el-option>
            <el-option label="Không chuyển" value="MONEY_WALLET"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- Bảng tóm tắt doanh thu -->
      <el-row :gutter="20" style="margin: 20px 0;">
        <el-col :span="6">
          <div class="stat-card stat-card--blue">
            <div class="stat-icon"><i class="el-icon-refresh"></i></div>
            <div class="stat-content">
              <div class="stat-title">Thiếu thừa tháng trước</div>
              <div class="stat-value">{{ formatCurrency(totalBeforeMoney) }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card stat-card--red">
            <div class="stat-icon"><i class="el-icon-bank-card"></i></div>
            <div class="stat-content">
              <div class="stat-title">Phải thu tháng này</div>
              <div class="stat-value">{{ formatCurrency(totalExpected) }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card stat-card--green">
            <div class="stat-icon"><i class="el-icon-wallet"></i></div>
            <div class="stat-content">
              <div class="stat-title">Đã thu tháng này</div>
              <div class="stat-value">{{ formatCurrency(totalCollected) }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card stat-card--purple">
            <div class="stat-icon"><i class="el-icon-money"></i></div>
            <div class="stat-content">
              <div class="stat-title">Thiếu thừa còn lại</div>
              <div class="stat-value">{{ formatCurrency(totalAfterMoney) }}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div style="height: 400px; width: 100%; position: relative;" v-loading="loadingRevenue">
         <ChartLine
            v-if="!loadingRevenue && revenueChartData.datasets.length"
            :checkLable="true"
            :chartData="revenueChartData"
            :options="revenueChartOptions"
            style="height: 100%; width: 100%;"
        ></ChartLine>
      </div>
    </div>
  </div>
</template>

<script>
import ChartLine from "@/views/chartStatistical/chart/ChartLine.vue";
import { kidStatusListExcel } from "@/constant/listCommon";
import TuitionStatisticService from "@/services/tutition_v3/TuitionStatisticService";

export default {
  name: "ManagingTuitionStatisticChart",
  components: { ChartLine },
  data() {
    return {
      kidStatusListExcel,
      loadingOrder: false,
      loadingRevenue: false,
      
      dataSearchOrder: {
        year: new Date().getFullYear().toString(),
        kidStatus: "",
        category: ""
      },
      dataSearchRevenue: {
        year: new Date().getFullYear().toString(),
        kidStatus: "",
        category: "",
        status: ""
      },

      orderChartData: { labels: [], datasets: [] },
      orderChartOptions: {},
      totalCompletedOrders: 0,
      totalPendingOrders: 0,

      revenueChartData: { labels: [], datasets: [] },
      revenueChartOptions: {},
      totalBeforeMoney: 0,
      totalExpected: 0,
      totalCollected: 0,
      totalAfterMoney: 0
    };
  },
  mounted() {
    this.loadDataOrder();
    this.loadDataRevenue();
  },
  methods: {
    formatCurrency(value) {
      if (!value) return "0 đ";
      return value.toLocaleString('vi-VN', {style: 'currency', currency: 'VND'});
    },
    async loadDataOrder() {
      this.loadingOrder = true;
      try {
        const response = await TuitionStatisticService.getOrderChart(this.dataSearchOrder);
        const dataList = response.data?.data || [];
        
        const labels = ["T1", "T2", "T3", "T4", "T5", "T6", "T7", "T8", "T9", "T10", "T11", "T12"];
        
        const completedOrders = Array.from({length: 12}, (_, i) => {
           const item = dataList.find(d => d.month === i + 1);
           return item ? item.completedOrders : 0;
        });
        const pendingOrders = Array.from({length: 12}, (_, i) => {
           const item = dataList.find(d => d.month === i + 1);
           return item ? item.pendingOrders : 0;
        });
        
        this.totalCompletedOrders = completedOrders.reduce((a, b) => a + b, 0);
        this.totalPendingOrders = pendingOrders.reduce((a, b) => a + b, 0);

        this.orderChartData = {
          labels,
          datasets: [
            {
              label: "Đã hoàn thành",
              data: completedOrders,
              borderColor: "#6aa5e3",
              backgroundColor: "rgba(106, 165, 227, 0.3)",
              fill: true,
              lineTension: 0.4,
              borderWidth: 2,
              pointBackgroundColor: "#fff",
              pointBorderColor: "#6aa5e3",
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
              datalabels: { align: "top", anchor: "end" }
            },
            {
              label: "Chưa hoàn thành",
              data: pendingOrders,
              borderColor: "#fd4803",
              backgroundColor: "rgba(253, 72, 3, 0.3)",
              fill: true,
              lineTension: 0.4,
              borderWidth: 2,
              pointBackgroundColor: "#fff",
              pointBorderColor: "#fd4803",
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
              datalabels: { align: "bottom", anchor: "start" }
            }
          ]
        };

        this.orderChartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.dataSearchOrder.category === "CLASS"
              ? "Phiếu thu học phí tất cả lớp"
              : (this.dataSearchOrder.category === "GROUP"
                ? "Phiếu thu học phí tất cả nhóm"
                : (this.dataSearchOrder.category === "PACKAGE"
                  ? "Phiếu thu học phí tất cả gói"
                  : "Phiếu thu học phí tất cả lớp, nhóm và gói")),
            fontSize: 20,
            fontColor: "#000",
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            datalabels: {
              color: "black",
              anchor: "end",
              align: "end",
              formatter: (value) => {
                return value > 0 ? value : "";
              },
            }
          },
          scales: {
            yAxes: [{ ticks: { beginAtZero: true } }]
          }
        };
      } catch (error) {
        console.error("Lỗi lấy dữ liệu biểu đồ Hóa đơn: ", error);
      } finally {
        this.loadingOrder = false;
      }
    },

    async loadDataRevenue() {
      this.loadingRevenue = true;
      try {
        const response = await TuitionStatisticService.getRevenueChart(this.dataSearchRevenue);
        const dataList = response.data?.data || [];
        const labels = ["T1", "T2", "T3", "T4", "T5", "T6", "T7", "T8", "T9", "T10", "T11", "T12"];
        
        const beforeMoney = Array.from({length: 12}, (_, i) => {
           const item = dataList.find(d => d.month === i + 1);
           return item ? item.beforeMoney : 0;
        });
        const expectedRevenue = Array.from({length: 12}, (_, i) => {
           const item = dataList.find(d => d.month === i + 1);
           return item ? item.expectedRevenue : 0;
        });
        const actualRevenue = Array.from({length: 12}, (_, i) => {
           const item = dataList.find(d => d.month === i + 1);
           return item ? item.actualRevenue : 0;
        });
        const afterMoney = Array.from({length: 12}, (_, i) => {
           const item = dataList.find(d => d.month === i + 1);
           return item ? item.afterMoney : 0;
        });

        this.totalBeforeMoney = beforeMoney.reduce((a, b) => a + b, 0);
        this.totalExpected = expectedRevenue.reduce((a, b) => a + b, 0);
        this.totalCollected = actualRevenue.reduce((a, b) => a + b, 0);
        this.totalAfterMoney = afterMoney.reduce((a, b) => a + b, 0);

        this.revenueChartData = {
          labels,
          datasets: [
            {
              label: "Thiếu thừa tháng trước",
              data: beforeMoney,
              borderColor: "#6aa5e3",
              backgroundColor: "rgba(106, 165, 227, 0.1)",
              fill: true,
              lineTension: 0.4,
              borderWidth: 2,
              pointBackgroundColor: "#fff",
              pointBorderColor: "#6aa5e3",
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
              datalabels: { align: "top", anchor: "end" }
            },
            {
              label: "Phải thu tháng này",
              data: expectedRevenue,
              borderColor: "#fd4803",
              backgroundColor: "rgba(253, 72, 3, 0.1)",
              fill: true,
              lineTension: 0.4,
              borderWidth: 2,
              pointBackgroundColor: "#fff",
              pointBorderColor: "#fd4803",
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
              datalabels: { align: "top", anchor: "end" }
            },
            {
              label: "Đã thu tháng này",
              data: actualRevenue,
              borderColor: "#34e527",
              backgroundColor: "rgba(52, 229, 39, 0.1)",
              fill: true,
              lineTension: 0.4,
              borderWidth: 2,
              pointBackgroundColor: "#fff",
              pointBorderColor: "#34e527",
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
              datalabels: { align: "bottom", anchor: "start" }
            },
            {
              label: "Thiếu thừa còn lại",
              data: afterMoney,
              borderColor: "#ac20f8",
              backgroundColor: "rgba(172, 32, 248, 0.1)",
              fill: true,
              lineTension: 0.4,
              borderWidth: 2,
              pointBackgroundColor: "#fff",
              pointBorderColor: "#ac20f8",
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
              datalabels: { align: "bottom", anchor: "start" }
            }
          ]
        };

        this.revenueChartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.dataSearchRevenue.category === "CLASS"
              ? "Doanh thu học phí tất cả lớp"
              : (this.dataSearchRevenue.category === "GROUP"
                ? "Doanh thu học phí tất cả nhóm"
                : (this.dataSearchRevenue.category === "PACKAGE"
                  ? "Doanh thu học phí tất cả gói"
                  : "Doanh thu học phí tất cả lớp, nhóm và gói")),
            fontSize: 20,
            fontColor: "#000",
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function(tooltipItem, data) {
                let datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                return datasetLabel + ': ' + tooltipItem.yLabel.toLocaleString('vi-VN', {style: 'currency', currency: 'VND'});
              }
            }
          },
          plugins: {
            datalabels: {
              color: "black",
              font: { size: 10 },
              formatter: (value) => {
                if (value !== 0) {
                  return (value / 1000000).toFixed(1).replace('.0', '') + 'Tr';
                }
                return "";
              },
            }
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function(value) {
                    if (Math.abs(value) >= 1000000) {
                      return (value / 1000000) + 'Tr';
                    }
                    return value.toLocaleString('vi-VN');
                  }
                }
              }
            ]
          }
        };
      } catch (error) {
        console.error("Lỗi lấy dữ liệu biểu đồ Doanh thu: ", error);
      } finally {
        this.loadingRevenue = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";

.tdi-toolbar-card {
  padding: 16px 20px;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
}

.tdi-card-head {
  margin-bottom: 16px;
  .tdi-card-title {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
  }
  .tdi-card-subtitle {
    font-size: 13px;
    color: #64748b;
    margin: 4px 0 0;
  }
}

.tdi-form-grid {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.tdi-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/deep/ .tdi-form-item .el-form-item__label {
  padding-bottom: 4px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 600;
  line-height: 1.5;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border: 1px solid #e2e8f0;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-2px);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin-right: 16px;
    flex-shrink: 0;
  }

  .stat-content {
    flex: 1;
    min-width: 0;
  }

  .stat-title {
    font-size: 13px;
    color: #64748b;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .stat-value {
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.stat-card--blue {
  .stat-icon { background: #eff6ff; color: #2563eb; }
}
.stat-card--red {
  .stat-icon { background: #fef2f2; color: #dc2626; }
}
.stat-card--green {
  .stat-icon { background: #f0fdf4; color: #16a34a; }
}
.stat-card--purple {
  .stat-icon { background: #faf5ff; color: #9333ea; }
}

</style>
